exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexRow.blockRow.small>.block{width:.875rem;height:.875rem;margin:.1875rem}.flexRow.blockRow.vertical{flex-direction:column-reverse}.vertical .additionalBlocksLabel{background:#fff;border:none;position:relative;left:-2px;font-size:.75rem;width:100%;text-align:center}.rowLabel{width:1.25rem;height:.875rem;margin:.1875rem 0;font-size:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-36db401b!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/StaticBlockRow.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-36db401b!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/StaticBlockRow.vue
// module chunks = 0